import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=c944941e&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c944941e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c944941e')) {
      api.createRecord('c944941e', component.options)
    } else {
      api.reload('c944941e', component.options)
    }
    module.hot.accept("./TemplateItem.vue?vue&type=template&id=c944941e&scoped=true&", function () {
      api.rerender('c944941e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/TemplateItem.vue"
export default component.exports